import React, { useState } from "react";
import './createUser';
import { Col, Row } from "antd";
import INPUT from './../../../components/input/input';
import SELECT from "../../../components/select/select";
import BUTTON from "../../../components/buttons/button";
import { color } from "../../../utils/themes/color";
import Axios from "./../../../utils/api/axiosConf";
import { url } from "./../../../utils/api/api";
import { RedNotif, GreenNotif } from "../../../utils/utils";


export default function CreateUser() {

    const genders = [{ "name": "آقا", "value": "male" }, { "name": "خانم", "value": "female" }]
    const role = [{ "name": "ورزشکار", "value": "athlete" }, { "name": "مربی", "value": "coach" }]
    const [user, setUser] = useState({ "role": "athlete", "gender": "male" });
    const [loading, setLoading] = useState(false);

    const submitUser = () => {
        setLoading(true);
        Axios.post(`${url}users/complete-identity-information`, user)
            .then(async (response) => {
                if (response.status === 200 || response.status === 201) {
                    GreenNotif(response.message);
                    setLoading(false);
                    setUser({ "role": "athlete", "gender": "male" })
                } else {
                    RedNotif(response.message);
                    setLoading(false);
                }
            })
            .catch((error) => {
                RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                console.log("error", error)
                setLoading(false)
            });
    }



    return (
        <>
            <Row style={{ marginBottom: '15px' }}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                    <p>برای ایجاد کاربر جدید فیلد های زیر را تکمیل نمایید</p>
                </Col>
            </Row>
            <Row gutter={20} style={{marginTop:"25px"}}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px" }}>
                        <p>نام کامل:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>
                    </div>
                    <br/>
                    <INPUT
                        i={(e) => setUser({ ...user, "fullName": e })}
                        value={user.fullName}
                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px" }}>
                        <p>موبایل:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>
                    </div>
                    <br/>
                    <INPUT
                        i={(e) => setUser({ ...user, "mobile": e })}
                        value={user.mobile} 
                        maxLength={11}
                        />
                </Col>
            </Row>
            <Row gutter={20} style={{marginTop:"25px"}}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px" }}>
                        <p>جنسیت:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>
                    </div>
                    <br/>
                    <SELECT
                        click={(e) => setUser({ ...user, "gender": e })}
                        items={genders}
                        value={user.gender} />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px" }}>
                        <p>نوع کاربری:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>
                    </div>
                    <br/>
                    <SELECT
                        value={user.role}
                        click={(e) => {
                            setUser({ ...user, "role": e });
                            if (e == "athlete") {
                                var x = user;
                                delete x.userName;
                                setUser(x)
                            }
                        }} items={role} />
                </Col>
            </Row>
            <Row gutter={20} style={{marginTop:"25px"}}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px" }}>
                        <p>سن کاربر:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>
                    </div>
                    <br/>
                    <INPUT
                        value={user.age}
                        i={(e) => setUser({ ...user, "age": e })}
                        type={"number"} 
                        maxLength={2}
                        />
                </Col>
                {
                    user.role == "coach" ?
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                            <div style={{ display: 'flex', padding: "0 12px" }}>
                                <p>نام کاربری:</p>
                                <p style={{ color: color.mandatoryColor }}>*</p>
                            </div>
                            <br/>
                            <INPUT
                                value={user.userName}
                                i={(e) => setUser({ ...user, "userName": e })} />
                        </Col>
                        : null
                }
            </Row>
            <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON
                            loading={loading[2]}
                            event={(e) => submitUser()}
                            text={"افزودن کاربر جدید"}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => window.location.reload()} text="پاک کردن فرم" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
        </>
    )
}